import Widget from "./Widget";
import sources from "../config/sources";
import { tmpl } from "../../templates/timelinewidget.js";
import { formatNumber, formatDate } from "../helpers/formatters";

/* charting */
import * as echarts from "echarts/core";
import { BarChart } from "echarts/charts";
import {
  TooltipComponent,
  GridComponent,
  DatasetComponent,
  VisualMapComponent,
} from "echarts/components";
import { LabelLayout, UniversalTransition } from "echarts/features";
import { CanvasRenderer } from "echarts/renderers";
echarts.use([
  TooltipComponent,
  GridComponent,
  DatasetComponent,
  BarChart,
  LabelLayout,
  UniversalTransition,
  CanvasRenderer,
  VisualMapComponent,
]);

export default class Timeline extends Widget {
  constructor(feed) {
    super();

    this.feed = feed;

    this.graph;

    if (!Object.prototype.hasOwnProperty.call(sources, feed)) {
      throw new Error(`Invalid feed: ${feed}`);
    }
  }

  init(el) {
    this.div = document.createElement("div");
    this.div.classList.add("sh-widget", "sh-timeline-widget", this._theme);
    this.setTemplate(tmpl);
    el.replaceWith(this.div);

    const data = this.getData(
      DATA_URL + "feed-stats/xbl?type=timeline&y=change&s=30"
    );
    data.then((data) => {
      const formatter = Intl.NumberFormat("en", { notation: "compact" });

      this.setTitle("Daily listing variations");
      this.setDescription(data.desc);

      // build graph
      const graphElement = this.div.querySelector('[data-element="graph"]');

      this.graph = echarts.init(graphElement);
      this.activateTooltips();
      this.clearLoading();

      this.graph.setOption({
        title: false,
        grid: {
          left: 50,
          right: 50,
          top: 50,
          bottom: 50,
        },
        visualMap: [
          {
            type: "piecewise",
            show: false,
            pieces: [
              {
                gt: 0,
                color: "red",
              },
              {
                lte: 0,
                color: "green",
              },
            ],
          },
        ],
        tooltip: {
          trigger: "item",
          axisPointer: "line",
          backgroundColor: "transparent",
          borderWidth: 0,
          padding: 0,
          formatter: function (params) {
            let i = params.dataIndex;
            if (i in data.yvalues) {
              return `<div class="sh-widget-tooltip">
                            <div class="sh-tooltip-header">${formatDate(
                              params.value[0]
                            )}</div>
                            <div class="sh-tooltip-body">Listings: <span class="number">${formatNumber(
                              data.yvalues[i]
                            )}</span></div>
                        </div>`;
            }
            `}`;
          },
        },
        xAxis: {
          type: "time",
          axisLine: {
            lineStyle: {
              color: "#fff",
            },
          },
          axisLabel: {
            formatter: "{MMM}, {dd} {yyyy}",
            color: "#fff",
            fontSize: 12,
            fontFamily: "sans-serif",
            fontWeight: 700,
            hideOverlap: true,
          },
        },
        yAxis: {
          min: "dataMin",
          axisLine: {
            onZero: true,
            show: false,
          },
          splitLine: {
            lineStyle: {
              color: "rgba(255, 255, 255, 0.3)",
            },
          },
          axisLabel: {
            formatter: function (d) {
              return `${formatter.format(d)}%`;
            },
            color: "#fff",
            fontSize: 12,
            fontFamily: "sans-serif",
            fontWeight: 700,
          },
        },
        series: [
          {
            type: "bar",
            data: data.data,
            barWidth: "6px",
            itemStyle: {
              borderRadius: 10,
            },
          },
        ],
      });
    });
  }
}
